var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-item"
  }, [_c('div', {
    class: {
      reward: true,
      real: _vm.item.nameK && _vm.item.type !== 'bonus'
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    on: {
      "click": function click($event) {
        return _vm.$emit('clickFunction', _vm.item);
      }
    }
  }, [_vm._t("bgmodule", function () {
    return [_c('div', {
      staticClass: "bgBlock"
    })];
  }), _c('k-image', {
    attrs: {
      "src": _vm.item.picUrl || _vm.item.icon,
      "loading": "lazy"
    }
  }), !_vm.showGift && _vm.item.unit ? _c('div', {
    staticClass: "award-num"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.type === "rewards" ? "x".concat(_vm.item.unit).concat(_vm.showD.includes(_vm.item.type || _vm.item.rewardType) ? "d" : "") : "") + " ")])]) : _vm._e()], 2), _vm.showGift ? _c('div', {
    staticClass: "price"
  }, [_c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/paytask/d_icon.png",
      "loading": "lazy"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.item.price))])], 1) : _vm.item.nameK ? _c('p', {
    staticClass: "award-name"
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: _vm.item.nameK
  })))]) : _c('p', {
    staticClass: "award-name"
  }, [_vm._v(_vm._s(_vm.item.name))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }